import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiReact,
  DiNpm
} from "react-icons/di";
import { SiRedux } from "react-icons/si";
import {SiMaterialUi} from "react-icons/si";

function FrontendStack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
       <Col xs={4} md={2} className="tech-icons">
       <DiReact/>
        <h4>React</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiRedux />
        <h4>Redux</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMaterialUi />
        <h4>Material-UI</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNpm />
        <h4>npm</h4>
      </Col>
    </Row>
  );
}

export default FrontendStack;
